import { createAsyncThunk } from "@reduxjs/toolkit";
import { CreditDetailsNetworkService } from "./CreditDetailsNetworkService";

export class CreditDetailsActions {
  // * get Credit broadcast details *//
  static getBroadcastCreditDetails = createAsyncThunk(
    "CreditDetailSlice/getBroadcastCreditDetails",
    (data: any, { dispatch, rejectWithValue }) => {
      return CreditDetailsNetworkService.getBroadcastCreditDetails(data)
        .then(async (response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    }
  );


//  static getBroadcastCreditDetails1 = createAsyncThunk(
//     "broadcastSlice/getAllBroadcastData",
//     (data: any, { dispatch, rejectWithValue }) => {
//       return CreditDetailsNetworkService.getBroadcastCreditDetails(data)
//         .then(async (response: any) => {
//           return response;
//         })
//         .catch((error: { response: unknown }) => {
//           return rejectWithValue(error?.response);
//         })
//         .finally(() => {});
//     }
//   );


  }
